export default {
  path: '/quality_check_values',
  name: 'quality_check_values',
  component: () => import('../components/qualitycheckvalue/Layout'),
  redirect: { name: 'QualityCheckValueList' },
  meta: {
    breadcrumb: 'qualitycheck.value.tests',
  },
  children: [
    /*
    {
      name: 'QualityCheckValueList',
      path: '',
      component: () => import('../views/qualitycheckvalue/List'),
      meta: {
        breadcrumb: 'qualitycheck.test.tests',
      },
    },
    {
      name: 'QualityCheckValueCreate',
      path: 'new',
      component: () => import('../views/qualitycheckvalue/Create'),
      meta: {
        breadcrumb: 'qualitycheck.test.tests',
      },
    },
    {
      name: 'QualityCheckValueUpdate',
      path: ':id/edit',
      component: () => import('../views/qualitycheckvalue/Update'),
      meta: {
        breadcrumb: 'qualitycheck.test.tests',
      },
    },
    {
      name: 'QualityCheckValueShow',
      path: ':id',
      component: () => import('../views/qualitycheckvalue/Show'),
      meta: {
        breadcrumb: 'qualitycheck.test.tests',
      },
    }
    */
  ]
};
